import React from 'react'

export default function LoadingSpinner({ 
  size = 'md', 
  text = 'Loading...', 
  fullScreen = false,
  className = '' 
}) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  }

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  }

  const spinner = (
    <div className={`flex flex-col items-center space-y-3 ${className}`}>
      <div className={`${sizeClasses[size]} border-4 border-primary/20 border-t-primary rounded-full animate-spin`}></div>
      {text && (
        <p className={`text-muted-foreground ${textSizeClasses[size]}`}>
          {text}
        </p>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="flex flex-col items-center space-y-5">
          <div className="relative flex items-center justify-center">
            <div className="absolute h-20 w-20 rounded-full border-4 border-primary/20 border-t-primary animate-spin"></div>
            <img
              src="/logo.png"
              alt="Cosmic Learning logo"
              className="h-12 w-12 object-contain drop-shadow-[0_0_14px_rgba(139,92,246,0.55)] animate-[pulse_2s_ease-in-out_infinite]"
            />
          </div>
          {text && (
            <p className="text-muted-foreground text-sm">{text}</p>
          )}
        </div>
      </div>
    )
  }

  return spinner
}

// Skeleton loading components
export function SkeletonCard({ className = '' }) {
  return (
    <div className={`bg-muted rounded-lg animate-pulse ${className}`}></div>
  )
}

export function SkeletonText({ lines = 1, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`h-4 bg-muted rounded animate-pulse ${
            i === lines - 1 ? 'w-3/4' : 'w-full'
          }`}
        ></div>
      ))}
    </div>
  )
}

export function SkeletonButton({ className = '' }) {
  return (
    <div className={`h-10 bg-muted rounded-lg animate-pulse ${className}`}></div>
  )
}

export function SkeletonInput({ className = '' }) {
  return (
    <div className={`h-10 bg-muted rounded-lg animate-pulse ${className}`}></div>
  )
}
